import {
  ColumnPolicyInput,
  CsvOptions,
  DataPolicyColumnEffect,
  LakehouseBigQueryConnectionInput,
  LakehouseClouderaConnectionInput,
  LakehouseConnectionTypeEnum,
  LakehouseDatabricksConnectionInput,
  LakehouseMySqlConnectionInput,
  LakehousePostgresConnectionInput,
  LakehouseSnowflakeConnectionInput,
  LakehouseSyncScheduleEnum,
  LakehouseTable,
  NodeInput,
  PostgresSslMode,
  RowPolicyInput,
  SnowflakeAuthType,
  SnowflakeOAuthCredentialsInput,
  TableColumnInput,
} from '@vendia/management-api-types'

import { AccessLevel } from '../csv-uploader/csv-uploader'
import { JoinType } from '../sql/query'

export type LakehouseClouderaConnection = {
  jdbcUrl: string
  atlasUrl: string
  username: string
  password: string
  database: string
}

export type LakehouseSnowflakeConnection = {
  authType: SnowflakeAuthType
  account: string
  warehouse: string
  database: string
  username?: string
  password?: string
  oauth?: SnowflakeOAuthCredentialsInput
  schema: string
  role: string
}

export type LakehousePostgresConnection = {
  host: string
  port: number
  database: string
  username: string
  password: string
  schema: string
  ssl?: PostgresSslMode
}

export type LakehouseMySQLConnection = {
  host: string
  port: number
  database: string
  user: string
  password: string
}

export type LakehouseDatabricksConnection = {
  catalog: string
  host: string
  httpPath: string
  schema: string
  clientId: string
  clientSecret: string
  oauthServer: string
}

export type LakehouseBigQueryConnection = {
  clientEmail: string
  privateKey: string
  projectId: string
  datasetId: string
}

export type LakehouseS3Connection = {
  crossAccountRoleArn: string
  crossAccountExternalId?: string
  bucketName: string
  bucketRegion: string
  encryptionKey?: string
}

// Shape of data stored in step form state
export type LakehouseTableForm = {
  name: string
  columnPolicies: ColumnPolicyInput[]
  rowPolicies: RowPolicyInput[]
  defaultColumnPolicyEffect: DataPolicyColumnEffect
  syncSchedule: LakehouseSyncScheduleEnum
  selectedVendiaTables?: LakehouseTable[]
  joinSql?: string
  queryDefinition?: BasicQueryDefinition
}

export type LakehouseFlowStepValues = {
  flowType: 'addTable' | 'updateTable'
  accessLevel: Record<string, AccessLevel>
  csvFile?: File
  csvOptions?: CsvOptions
  uniName?: string
  nodeName?: string
  alias: string
  namespace: string
  randomSuffix: string
  nodes: NodeInput[]
  schema: string
  schemaTemplate: string
  enableFinancialServices: boolean
  invites: string[]
  selectedTables: Record<string, boolean>
  source: {
    connection: LakehouseConnectionTypeEnum | undefined
    availableFiles?: string[]
    availableTables: string[]
    selectedFile?: string
    selectedTable: string
    sourceRegion: string
    bigquery?: LakehouseBigQueryConnectionInput
    cloudera?: LakehouseClouderaConnectionInput
    snowflake?: LakehouseSnowflakeConnectionInput
    postgres?: LakehousePostgresConnectionInput
    s3?: LakehouseS3Connection
    postgresConnectionString?: string
    mysql?: LakehouseMySqlConnectionInput
    mysqlConnectionString?: string
    databricks?: LakehouseDatabricksConnectionInput
    databricksConnectionString?: string
  }
  selectedTableColumns: TableColumnInput[]
  product: LakehouseTableForm
  lastUpdatedColumn: string
  lastUpdatedColumnFormat: string
  useIncrementalUpdates: boolean
  keyColumns: string[]
  existingVendiaTables?: LakehouseTable[]
  joinTables?: any[]
  connectionName: string
  connectionId?: string
  joinTableKey?: string
  tableKey?: string // To identify the current table being edited
  csvConfig?: Record<string, any>
  parsedCsvData?: Record<string, any>[]
  parsedCsvFields?: any[]
  deletedVendiaTables?: LakehouseTable[]
}

// TODO: This is a placeholder for now. We'll need to add more fields to this object to support
// the full range of query types.
export type BasicQueryDefinition = {
  leftTable: {
    allColumns?: TableColumnInput[]
    nodeName?: string
    selectedColumns?: TableColumnInput[]
    table: string
  }
  rightTable: {
    allColumns?: TableColumnInput[]
    nodeName?: string
    selectedColumns?: TableColumnInput[]
    table: string
  }
  joinConditions: JoinCondition[]
  joinType: JoinType
  returnAllColumns?: boolean
  sql?: string
}

export type JoinCondition = {
  leftField: TableColumnInput
  rightField: TableColumnInput
}

export enum TaskDefinitionType {
  INGESTION = 'INGESTION',
  DISTRIBUTION = 'DISTRIBUTION',
}

export enum DatasetType {
  TABLE = 'TABLE',
  ICEBERG = 'ICEBERG',
  DELTALAKE = 'DELTALAKE',
  CSV = 'CSV',
}
